
import { BrowserRouter, } from 'react-router-dom';
import { ServicesProvider } from './context/ContextServices';
import Routers from './routers/Routers';
import { ContextUserProvider } from './context/ContextUser';


function App() {
  return (
    <ServicesProvider>
      <ContextUserProvider>
        <BrowserRouter>
          <Routers />
        </BrowserRouter>
      </ContextUserProvider>
    </ServicesProvider>
  );
}

export default App;
